



























import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";
import { Base, SurveyModel, Cover, CoverCell } from "survey-core";
import BaseVue from "../../base";

@Component
export class HeaderCellViewModel extends Vue {
  @Prop() model: CoverCell;
  constructor(props: any) {
    super(props);
  }
}

Vue.component("sv-header-cell", HeaderCellViewModel);
export default HeaderCellViewModel;
